import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n/i18n";

export default function LanguageSwitcher() {
    const { language, t } = useI18n();
    const location = useLocation();
    const navigate = useNavigate();
    const currentPath = location.pathname || "/";
    const switchLanguage = (next) => {
        const withoutPrefix = currentPath.replace(/^\/uk(\/|$)/, "/");
        const target = next === "uk"
            ? `/uk${withoutPrefix === "/" ? "" : withoutPrefix}`
            : withoutPrefix;
        navigate(target || "/");
    };

    return (
        <div className="languageSwitcher" aria-label={t("language.label")}>
            {language === "en" ? (
                <>
                    <span className="languageOption languageOption--active" aria-current="true">
                        Eng
                    </span>
                    <button
                        type="button"
                        className="languageOption languageOption--button"
                        onClick={() => switchLanguage("uk")}
                    >
                        Ukr
                    </button>
                </>
            ) : (
                <>
                    <button
                        type="button"
                        className="languageOption languageOption--button"
                        onClick={() => switchLanguage("en")}
                    >
                        Eng
                    </button>
                    <span className="languageOption languageOption--active" aria-current="true">
                        Ukr
                    </span>
                </>
            )}
        </div>
    );
}
